import React, { useCallback, useState } from 'react';

import { useOAuth } from '<sections>/oauth';

export default function DropboxPane({
  children: renderBody,
  createCredential,
  credential,
}) {
  const [creating, setCreating] = useState(false);

  const createNewCredential = useCallback(
    async ({ code, scope, redirectURL } = {}) => {
      setCreating(true);

      await createCredential({
        variables: {
          input: {
            ...(!credential && { name: `DropBox` }),
            ...(credential && { ID: credential.ID }),
            provider: {
              providerName: 'dropbox',
              credName: 'oauthCode',
              credParams: {
                code,
                scope,
                redirectURL,
              },
            },
          },
        },
      });

      setCreating(false);
    },
    [createCredential, credential]
  );

  const [doOAuth, popupVisible] = useOAuth('dropbox', createNewCredential);

  const body = <></>;

  return renderBody(body, doOAuth, popupVisible || creating);
}
